
export interface Ipage {
    name: string
    component: any
    params?: {
        [key: string]: any
    }
}
interface IfnObj {
    name: string
    params?: { [key: string]: any }
}
import { reactive, computed } from 'vue';


export function useComponentRoute<T extends Ipage>(inComponentList: T[]) {
    const pageList = reactive<Ipage[]>([{...inComponentList[0]}])
    const lastonePage = computed(() => pageList[pageList.length - 1])

    //清空
    const clearFn = () => {
        pageList.length = 0
    }

    // 前进
    const goFn = (obj: IfnObj) => {
        const { params, name } = obj
        for (let i = 0; i < inComponentList.length; i++) {
            const item = inComponentList[i]
            if (item.name === name) {
                pageList.push({
                    ...item,
                    params
                })
            }
        }
    }

    // 返回
    const backFn = (obj?: { [key: string]: any }, backLength?: number) => {
        const l = backLength || 1
        if (pageList.length > l) {
            pageList.length = pageList.length - l
        }
        if (obj) {
            pageList[pageList.length - 1].params = obj
        }
    }

    // 替换
    const replaceFn = (obj: IfnObj) => {
        pageList.pop()
        goFn(obj)
    }

    // 重定向
    const reFreshFn = (obj?: IfnObj) => {
        clearFn()
        if (obj) {
            goFn(obj)
        } else if (inComponentList) {
            goFn(inComponentList[0])
        }
    }




    return {
        pageList,
        lastonePage,

        clearFn,
        goFn,
        replaceFn,
        reFreshFn,
        backFn
    }

}
